import React from 'react';
import { Outlet } from 'react-router-dom';

import { PageContainer } from '@flixbus/honeycomb-react';

import AppHeader from 'common/AppHeader';
import AuthGuard from 'common/AuthGuard';
import { ActiveElementsProvider } from 'global/ActiveElements/ActiveElementsProvider';
import { RootActiveElementsHost } from 'global/ActiveElements/RootActiveElementsHost';

const NavbarWrapper = () => {
	return (
		<>
			<AppHeader />
			<PageContainer hasFixedHeader>
				<ActiveElementsProvider>
					<main className="main-container">
						<AuthGuard>
							<Outlet />
							<RootActiveElementsHost />
						</AuthGuard>
					</main>
				</ActiveElementsProvider>
			</PageContainer>
		</>
	);
};

export default NavbarWrapper;
